import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import ParticlesComponentStar from "./subComponents/ParticlesComponentStar";
import ParticlesComponent from "./subComponents/ParticlesComponent";
import gold1 from "../assets/gold1.jpg";

const publicHolidays = [
  // 2025
  { name: "Waitangi Day", date: "2025-02-06" },
  { name: "Good Friday", date: "2025-04-18" },
  { name: "Easter Monday", date: "2025-04-21" },
  { name: "Anzac Day", date: "2025-04-25", isOpen: true },
  { name: "King's Birthday", date: "2025-06-02" },
  { name: "Matariki", date: "2025-06-20" },
  { name: "Labour Day", date: "2025-10-27" },
  { name: "Canterbury Day", date: "2025-11-14" },
  { name: "Christmas Day", date: "2025-12-25" },
  { name: "Boxing Day", date: "2025-12-26" },

  // 2026
  { name: "Waitangi Day", date: "2026-02-06" },
  { name: "Good Friday", date: "2026-04-03" },
  { name: "Easter Monday", date: "2026-04-06" },
  { name: "Anzac Day", date: "2026-04-25" },
  { name: "King's Birthday", date: "2026-06-01" },
  { name: "Matariki", date: "2026-07-10" },
  { name: "Labour Day", date: "2026-10-26" },
  { name: "Canterbury Day", date: "2026-11-13" },
  { name: "Christmas Day", date: "2026-12-25" },
  { name: "Boxing Day", date: "2026-12-26" },

  // 2027
  { name: "Waitangi Day", date: "2027-02-06" },
  { name: "Good Friday", date: "2027-03-26" },
  { name: "Easter Monday", date: "2027-03-29" },
  { name: "Anzac Day", date: "2027-04-25", isOpen: true },
  { name: "King's Birthday", date: "2027-06-07" },
  { name: "Matariki", date: "2027-06-25" },
  { name: "Labour Day", date: "2027-10-25" },
  { name: "Canterbury Day", date: "2027-11-12" },
  { name: "Christmas Day", date: "2027-12-25" },
  { name: "Boxing Day", date: "2027-12-26" },
];

const customClose = [
  {
    name: "Close",
    date: "2026-04-27",
    message: "We are closed for a private event",
  },
];

function getCustomCloseToday(date = new Date()) {
  const todayISO = date.toISOString().slice(0, 10);
  return customClose.find((d) => d.date === todayISO) || null;
}

const schoolHolidays = [
  {
    year: 2025,
    terms: [
      { name: "Term 1 Holidays", start: "2025-04-12", end: "2025-04-27" },
      { name: "Term 2 Holidays", start: "2025-06-28", end: "2025-07-13" },
      { name: "Term 3 Holidays", start: "2025-09-20", end: "2025-10-05" },
      { name: "Summer Holidays", start: "2025-12-15", end: "2026-01-26" },
    ],
  },
  {
    year: 2026,
    terms: [
      { name: "Term 1 Holidays", start: "2026-04-03", end: "2026-04-19" },
      { name: "Term 2 Holidays", start: "2026-07-04", end: "2026-07-19" },
      { name: "Term 3 Holidays", start: "2026-09-26", end: "2026-10-11" },
      { name: "Summer Holidays", start: "2026-12-19", end: "2027-01-24" },
    ],
  },
  {
    year: 2027,
    terms: [
      { name: "Term 1 Holidays", start: "2027-04-10", end: "2027-04-25" },
      { name: "Term 2 Holidays", start: "2027-07-03", end: "2027-07-18" },
      { name: "Term 3 Holidays", start: "2027-09-25", end: "2027-10-10" },
      { name: "Summer Holidays", start: "2027-12-18", end: "2028-01-23" },
    ],
  },
];

function getUpcomingPublicHoliday() {
  const today = new Date();
  for (let holiday of publicHolidays) {
    const holidayDate = new Date(holiday.date);
    const diffDays = Math.floor((holidayDate - today) / (1000 * 60 * 60 * 24));
    if (diffDays >= 0 && diffDays <= 7) {
      return holiday;
    }
  }
  return null;
}

function getUpcomingPublicHolidays() {
  const today = new Date();

  return publicHolidays.filter((holiday) => {
    const holidayDate = new Date(holiday.date);
    const diffDays = Math.floor((holidayDate - today) / (1000 * 60 * 60 * 24));
    return diffDays >= 0 && diffDays <= 7;
  });
}

function getCurrentSchoolHoliday(date = new Date()) {
  const isoToday = date.toISOString().slice(0, 10);
  const todayDate = new Date(isoToday);

  for (let entry of schoolHolidays) {
    for (let term of entry.terms) {
      const start = new Date(term.start);
      const end = new Date(term.end);

      const daysUntilStart = Math.ceil(
        (start - todayDate) / (1000 * 60 * 60 * 24),
      );

      // If today is within the holiday OR within 5 days before it starts
      if (
        (todayDate >= start && todayDate <= end) ||
        (daysUntilStart > 0 && daysUntilStart <= 7)
      ) {
        return term;
      }
    }
  }

  return null;
}

const Container = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  touch-action: none;
  overflow: hidden;

  width: 100vw;
  height: 100vh;

  z-index: 6;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: #1f263b;
  // background-color: var(--secondary-color);
  // background: url(${gold1})

  // background-image: linear-gradient(180deg,
  //     rgba(212,175,55, 1),
  //     rgba(212,175,55, 1)
  //   ),
  //   url(${gold1});

  color: var(--third-color);

  svg {
    margin-top: 4rem;
    margin-bottom: -5rem;
    width: 10vw;
    height: auto;
    overflow: visible;
    stroke-linejoin: round;
    stroke-linecap: round;
    z-index: 6;
    g {
      path {
        // stroke: #3d007a;
        stroke: white;
      }
    }
  }

  img {
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 48em) {
    svg {
      margin-top: rem;
      width: 15vw;
      margin-left: 0rem;
      margin-bottom: 0;
    }
  }
`;

const Text = styled(motion.span)`
  font-size: 3rem;
  color: var(--secondary-color: );
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  @media (max-width: 48em) {
    font-size: 1rem;
    margin-left: 1rem;
  }
`;

const TextNotice = styled(motion.span)`
  width: 30vw;
  font-size: 1.5rem;
  background: var(--third-color);
  color: white;
  padding: 1rem;
  border: 2px dashed white;
  text-align: center;
  .color {
    color: red;
    font-weight: 700;
    text-transform: uppercase;
    font-family: "Mountains of Christmas", serif;
  }

  .colorOpen {
    color: red;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 2.5rem;
    font-family: "Mountains of Christmas", serif;
  }

  @media (max-width: 48em) {
    width: 80vw;
    font-size: 0.95rem;
    margin-left: 0rem;
    .colorOpen {
      font-size: 1.5rem;
    }
  }
`;

const textVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,

    transition: {
      duration: 1,
      yoyo: Infinity, // repeats infinite times
      ease: "easeInOut",
    },
  },
};

const pathVariants = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,

    transition: {
      duration: 4,
      ease: "easeInOut",
    },
  },
};

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid white;
  color: white;
  font-size: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease;

  &:hover {
    background: white;
    color: black;
  }
`;

const icon = {
  hidden: {
    pathLength: 0,
    fill: "rgba(255, 255, 255, 0)",
  },
  visible: {
    pathLength: 1,
    fill: "rgba(255, 255, 255, 1)",
  },
};

function getPublicHolidayToday(date = new Date()) {
  const todayISO = date.toISOString().slice(0, 10);
  return publicHolidays.find((h) => h.date === todayISO) || null;
}

const Loader = ({ onClose }) => {
  const today = new Date();

  const publicHolidayToday = getPublicHolidayToday(today);
  const upcomingHoliday = getUpcomingPublicHoliday();
  const upcomingHolidays = getUpcomingPublicHolidays();
  const currentSchoolHoliday = getCurrentSchoolHoliday(today);
  const isNewYearsDay =
    publicHolidayToday?.date === "2026-01-01" ||
    publicHolidayToday?.date === "2025-01-01" ||
    publicHolidayToday?.date === "2027-01-01";

  const customCloseToday = getCustomCloseToday(today);
  // Public holiday overrides school holiday
  const isClosedToday = Boolean(publicHolidayToday || customCloseToday);
  const isChristmasDay = today.getMonth() === 11 && today.getDate() === 25; // December 25

  function getUpcomingCustomCloses() {
    const today = new Date();
    const todayOnly = new Date(today.toISOString().slice(0, 10)); // ✅ remove time

    return customClose.filter((item) => {
      const closeDate = new Date(item.date);

      const diffDays = Math.floor(
        (closeDate - todayOnly) / (1000 * 60 * 60 * 24),
      );

      return diffDays >= 0 && diffDays <= 30; // include today
    });
  }

  const upcomingCustomCloses = getUpcomingCustomCloses();

  console.log({ upcomingCustomCloses });

  const shouldShowNotice =
    customCloseToday ||
    upcomingCustomCloses.length > 0 ||
    publicHolidayToday ||
    upcomingHolidays.length > 0 ||
    currentSchoolHoliday ||
    isChristmasDay;

  return (
    <Container
      initial={{
        y: 0,
        opacity: 1,
      }}
      exit={{
        y: "100%",
        opacity: 0,
      }}
      transition={{
        duration: 2,
      }}
    >
      <ParticlesComponent />
      <CloseButton onClick={onClose}>✕</CloseButton>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 24 24"
        height="48px"
        // viewBox="0 0 24 24"
        viewBox="250 100 100 100"
        width="48px"
        fill="none"
      >
        <g>
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 112.8609,76.136 -1.2002,-22.5 -8.5499,0.2999 -8.85,0.9 -9,1.5001 -8.8501,2.7 -9.1499,4.9499 -6.0001,4.9501 -3.3001,5.55 -1.6498,6.5999 -0.3002,7.6501 0.4502,7.0501 1.9499,5.6999 3.6,4.7999 5.6999,5.4 7.0501,3.3001 7.3499,0.9 10.0503,0.1499 9.4498,-0.9 7.8001,-2.3998 10.5001,-3.9002 -17.85,-4.1998 4.7999,-11.4001 -5.6999,1.5001 -6.3,0.5998 -6.6002,-0.5998 -3.1499,-1.8 -1.3501,-2.7003 -0.5998,-3.8999 1.6497,-2.9999 2.8503,-2.8499 3.8999,-2.1002 4.35,-1.3499 3.75,-0.6001 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 128.9109,49.7358 -21.3001,51.9001 22.9501,4.9502 0.3,-3.3001 2.55,-2.85 13.35,1.3499 1.05,4.0501 0.6001,4.65 14.9998,4.5 8.5501,0.4501 -0.6,-3.3001 h -7.9501 l 0.3002,-57.7502 z m 15.8998,16.8001 -7.2,18.15 9.0003,1.5001 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 169.7111,54.9856 v 54.3002 l 28.1999,-3.4501 7.3499,-1.5 7.0501,-2.3999 4.35,-3.7499 0.6001,-3.0002 2.2499,-45 -3.6,-2.85 -3.2998,-1.3501 -5.1001,-0.2999 z m 21.1498,10.9502 -0.5998,23.8499 3.8999,0.15 3.8999,-2.3999 4.2001,-3.45 2.7,-4.8002 0.2999,-5.0998 -1.3498,-4.65 -2.7,-2.7 -2.5501,-1.3501 -4.0498,-0.15 z"
          />

          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 222.6614,53.1102 -2.55,53.1003 17.5501,4.9498 7.35,0.9 12.3001,-0.4498 6.7501,-3.6 4.3498,-5.55 1.65,-10.5001 -0.5998,-10.3501 -4.35,-19.65 -3.1502,-5.2498 -4.0498,-3.7502 z m 18.6001,18.0003 0.4502,23.5499 3.4497,-1.1999 4.2001,-2.1002 2.9999,-2.9999 1.3502,-3.45 v -4.7999 l -2.0999,-4.5 -3.4501,-2.7 -4.5,-1.8 z"
          />

          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 263.6116,46.8102 11.8499,43.2003 -0.4498,19.9499 2.8499,1.05 14.55,-0.5998 0.6001,-12.6003 20.0999,-41.8499 -18.7501,-5.25 -7.0498,16.3499 -3.7502,-17.3999 z"
          />

          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 349.1118,44.4104 -7.5001,-0.7501 -6.45,-0.2999 -6.3,0.5999 -5.6999,2.1001 -4.8002,1.95 -4.1998,3.7499 4.5,2.1 -10.2002,22.35 1.6501,4.0501 2.55,4.3501 3.75,3.2998 3.45,1.5001 5.25,1.5001 3.75,-0.6001 4.9501,-0.9 2.2499,0.6001 0.75,1.8 -2.2501,2.55 -3.6,1.4998 -5.8499,0.9 -11.4,0.6001 1.3501,13.0502 h 20.7 l 5.6999,-1.0503 3.6,-2.5497 4.35,-4.3501 4.2001,-6.9001 0.7501,-5.6999 -0.1502,-8.85 -1.8,-6.4502 -2.7,-4.65 -4.1999,-1.4998 h -4.6502 l -4.3498,1.4998 -6.9001,0.6001 -1.3501,-1.95 0.4501,-3.0001 2.1,-1.8 3.3,-1.05 4.5,-0.4499 11.2499,-0.4501 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 353.6121,44.86 -0.4498,25.3499 2.7,3.9002 1.65,4.5 0.9,10.05 -0.6001,7.4999 -2.55,6.3 -3.75,6.3 20.7,1.3501 0.4499,-18.3002 10.9502,3.9002 -0.3002,14.8499 12.6,-0.2999 h 6.1501 l 1.0499,-34.35 1.9503,-18.75 -19.0503,-4.8002 -2.0999,21.7502 -11.2501,-1.3501 0.1502,-22.7999 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 412.4126,46.9599 -6.7499,30.0002 -0.4501,31.9498 16.95,0.9 v -8.1 h 15.9001 l 0.15,8.1 21.7499,-0.2999 -13.7999,-56.7 z m 17.4002,19.5001 -4.9502,19.9499 9.4502,0.15 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 503.0124,76.0598 1.6501,-20.85 -9.15,-0.75 -9,-0.15 -7.3502,0.4499 -7.7998,2.2501 -5.7002,2.85 -4.0499,4.6499 -7.05,8.5502 9.75,37.8 -3.3001,0.2999 5.1001,2.1002 11.0999,0.1499 6.1501,-0.1499 7.2,-1.5001 6.4499,-2.85 4.0502,-3.6 0.4498,-15.6002 -3.8999,1.9503 -5.1001,1.0499 -5.6999,0.9 -3.9002,-0.1499 -4.9498,-0.7501 -2.5501,-2.7 -1.0499,-3.6 1.5001,-3.9002 3.4497,-3.6 2.8503,-2.3998 5.25,-1.2002 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 510.5123,45.6097 -4.1998,58.5003 21.8999,2.7 1.95,-17.4002 10.2002,18.4502 28.3498,2.6997 -17.85,-27.9 23.1001,-24.0001 -29.7,-5.9998 -13.0502,17.3999 1.1999,-19.3502 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 266.9083,124.5844 0.0751,-6.2249 -1.2751,-3.1501 -1.8748,-1.8749 -17.6252,0.2251 -2.325,0.0748 -6.7499,2.85 -5.1752,2.925 -3.1499,3.225 -1.7251,2.2502 -0.7501,3.075 0.3751,4.0498 1.8751,4.0502 2.6249,2.7 4.2752,2.9251 5.25,1.9499 8.25,0.7501 8.325,-0.0752 9.7501,-1.1999 0.0748,-9.9751 -2.325,0.15 -2.7,1.5752 -3.8999,0.5998 -4.35,0.0751 -3.075,-0.4501 -3.4501,-1.3499 -2.175,-2.2501 -0.375,-1.95 0.375,-2.7 2.325,-2.6249 3.45,-1.8 3.6,-0.6001 4.65,0.15 2.2501,0.2999 3.4501,1.5752 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 275.4587,113.5596 v 29.7 h 18.75 v -29.7 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 300.3588,113.2597 h 40.0501 v 8.3999 h -10.5001 v 21.45 h -18.2999 v -21.45 h -11.2501 z"
          />
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
            d="m 343.1832,112.9601 17.1,16.425 0.0751,13.9499 18.8249,-0.0748 -0.0749,-14.1753 16.0501,-16.575 h -19.6501 l -5.8501,8.7001 -6.5251,-8.1 z"
          />
        </g>
      </svg>{" "}
      <Text variants={textVariants} initial="hidden" animate="visible">
        Welcome to Christchurch minigolf
        <br />
      </Text>
      {shouldShowNotice && (
        <TextNotice>
          {isChristmasDay && (
            <>
              <p>
                <span className="colorOpen">🎄 Christmas Day</span>
              </p>
              <p>
                <span className="color">Date:</span>{" "}
                {today.toLocaleDateString("en-NZ", {
                  weekday: "long",
                  month: "long",
                  day: "numeric",
                })}
              </p>
              <p className="color">We are closed today.</p>
              <hr style={{ margin: "1rem 0", opacity: 0.3 }} />
            </>
          )}

          {/* 🔴 UPCOMING CUSTOM CLOSE */}
          {upcomingCustomCloses.length > 0 && (
            <>
              {upcomingCustomCloses.map((item, index) => (
                <div key={index}>
                  <p>
                    <span className="colorOpen">{item.name}</span>
                  </p>

                  <p>
                    <span className="color">Date:</span>{" "}
                    {new Date(item.date).toLocaleDateString("en-NZ", {
                      weekday: "long",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>

                  <p className="color">❌ {item.message}</p>

                  <hr style={{ margin: "1rem 0", opacity: 0.3 }} />
                </div>
              ))}
            </>
          )}

          {/* 🔴 CUSTOM CLOSE */}

          {/* {!isChristmasDay && upcomingHoliday && (
            <>
              <p>
                <span className="colorOpen">{upcomingHoliday.name}</span>
              </p>
              <p>
                <span className="color">Date:</span>{" "}
                {new Date(upcomingHoliday.date).toLocaleDateString("en-NZ", {
                  weekday: "long",
                  month: "long",
                  day: "numeric",
                })}
              </p>

              {upcomingHoliday.date === "2025-11-15" ? (
                <div
                  style={{
                    backgroundColor: "transparent",
                    color: "#b388ff",
                    padding: "1rem",
                    borderRadius: "8px",
                    border: "10px dotted #b388ff",
                    marginTop: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    textAlign: "center",
                    animation: "dot-flash 1.2s infinite alternate", // 💡 animate only dots
                  }}
                >
                  <span style={{ color: "#b388ff", fontSize: "1.8rem" }}>
                    😔
                  </span>{" "}
                  <span
                    style={{
                      animation: "dot-flash 1.2s infinite alternate", // 💡 animate only dots
                    }}
                  >
                    We are closed
                  </span>{" "}
                  ❌
                  <style>
                    {`
        @keyframes dot-flash {
          0% {
            border-color: #b388ff; 
          }
          50% {
            border-color: #7e22ce; 
          }
          100% {
            border-color: #c084fc; 
          }
        }
      `}
                  </style>
                </div>
              ) : (
                <p>⏰ Opening Hours: 10AM - 6PM</p>
              )}

              <hr style={{ margin: "1rem 0", opacity: 0.3 }} />
            </>
          )} */}

          {!isChristmasDay && upcomingHolidays.length > 0 && (
            <>
              {upcomingHolidays.map((holiday, index) => (
                <div key={index}>
                  <p>
                    <span className="colorOpen">{holiday.name}</span>
                  </p>
                  <p>
                    <span className="color">Date:</span>{" "}
                    {new Date(holiday.date).toLocaleDateString("en-NZ", {
                      weekday: "long",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                  <p>⏰ Opening Hours: 10AM - 6PM</p>
                  <hr style={{ margin: "1rem 0", opacity: 0.3 }} />
                </div>
              ))}
            </>
          )}

          {/* 🔴 PUBLIC HOLIDAY — CLOSED */}
          {publicHolidayToday && (
            <>
              <p>
                <span className="colorOpen">{publicHolidayToday.name}</span>
              </p>

              <p>
                <span className="color">Date:</span>{" "}
                {new Date(publicHolidayToday.date).toLocaleDateString("en-NZ", {
                  weekday: "long",
                  month: "long",
                  day: "numeric",
                })}
              </p>

              {publicHolidayToday.name.includes("New Year") ? (
                <p className="color">❌ We are CLOSED on New Year’s Day</p>
              ) : (
                <p className="color">❌ We are CLOSED today</p>
              )}

              <hr style={{ margin: "1rem 0", opacity: 0.3 }} />
            </>
          )}

          {/* 🟢 SCHOOL HOLIDAY — OPEN (ONLY if not public holiday) */}
          {currentSchoolHoliday && !publicHolidayToday && (
            <>
              <p>
                <span className="colorOpen">{currentSchoolHoliday.name}</span>
              </p>
              <p>
                📅{" "}
                {new Date(currentSchoolHoliday.start).toLocaleDateString(
                  "en-NZ",
                )}{" "}
                –{" "}
                {new Date(currentSchoolHoliday.end).toLocaleDateString("en-NZ")}
              </p>
              <p>🎉 We're open 7 days during school holidays!</p>
              {/* <p style={{ fontSize: "0.95em", opacity: 0.9 }}>
                ❗ Closed on <strong>New Year’s Day (1 January 2026)</strong>
              </p> */}
            </>
          )}
        </TextNotice>
      )}
    </Container>
  );
};

export default Loader;
